import { keepPreviousData, useQuery } from "@tanstack/vue-query"

import { PensionCategoriesEnum } from "../types/portfolio"

export const PensionRecommendationsQueryKey = "PensionRecommendationsService.getRecommendations"

function transformRecommendations(recs: PensionRecommendation[]) {
  return recs.map((rec) => ({
    ...rec,
    transactions: rec.transactions.map((t) => {
      let action

      const currentHoldings = t.currentHoldings
      const targetHoldings = t.targetHoldings

      if (currentHoldings.length === 0 && targetHoldings.length > 0) {
        action = "NEW"
      } else if (
        currentHoldings.length === targetHoldings.length &&
        currentHoldings.every((currentHolding) =>
          targetHoldings.some((targetHolding) => targetHolding.fundId === currentHolding.fundId)
        )
      ) {
        action = "NO_CHANGE"
      } else if (currentHoldings.length > targetHoldings.length) {
        action = "POLICY_CONSOLIDATION"
      } else {
        action = "POLICY_TRANSFER"
      }

      return { ...t, action }
    }),
  }))
}

export function useMyPensionRecommendations(
  category?: Ref<PensionCategoriesEnum | undefined>,
  options?: QueryOptions<PensionRecommendation[]> & { key?: string }
) {
  const { pensionRecommendationService } = usePensionRecommendationService()
  return useQuery<PensionRecommendation[]>({
    queryKey: [PensionRecommendationsQueryKey, category, options?.key].filter(Boolean),
    queryFn: ({ signal }) =>
      pensionRecommendationService.value
        .getRecommendations({
          signal,
          params: jsonClean({ category: category?.value }),
        })
        .then(transformRecommendations),
    // queryFn: ({ signal }) => {
    //   // return pensionRecommendationService.value.getRecommendations({
    //   //   signal,
    //   //   params: jsonClean({ category: category?.value }),
    //   // })
    //   return Promise.resolve(mock.data)
    // },
    staleTime: 0,
    refetchOnReconnect: false,
    placeholderData: keepPreviousData,
    retry: false,
    ...options,
  })
}

const mock = {
  data: [
    // new pension
    // {
    //   id: "1",
    //   title: "רכישת סכום ביטוח חיים חדש",
    //   description: "רכישת ביטוח חיים למקרה פטירה לאור סטאטוס משפחתי וצורך על פי הנתונים.",
    //   reason: "",
    //   category: "PENSION",
    //   isSelected: null,
    //   transactions: [
    //     {
    //       id: "3452435435",
    //       title: null,
    //       description: null,
    //       isDynamic: false,
    //       action: "NEW",
    //       simulation: {
    //         title: "כיסוי ביטוחי סכום חד פעמי במקרה פטירה ליורשיך",
    //         amount: "30000",
    //       },
    //       currentHoldings: [{}],
    //       targetHoldings: [
    //         {
    //           id: "341655435",
    //           category: "PENSION",
    //           fundId: "14855",
    //           fundShortText: "אנליסט קופת גמל להשקעה כללי",
    //           companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
    //           futureSavings: "150000",
    //         },
    //       ],
    //     },
    //   ],
    // },

    // new pension
    {
      id: "10",
      title: "רכישת סכום ביטוח חיים חדש",
      description: "רכישת ביטוח חיים למקרה פטירה לאור סטאטוס משפחתי וצורך על פי הנתונים.",
      reason: "",
      category: "CHILDSAVING",
      isSelected: null,
      transactions: [
        {
          id: "234324234",
          title: null,
          description: null,
          isDynamic: false,
          action: "NEW",
          simulation: {
            title: "כיסוי ביטוחי סכום חד פעמי במקרה פטירה ליורשיך",
            amount: "30000",
          },
          currentHoldings: [{}],
          targetHoldings: [
            {
              id: "3454355435",
              category: "CHILDSAVING",
              fundId: "14855",
              fundShortText: "אנליסט קופת גמל להשקעה כללי",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "150000",
            },
          ],
        },
      ],
    },

    // new pension
    {
      id: "9",
      title: "רכישת סכום ביטוח חיים חדש",
      description: "רכישת ביטוח חיים למקרה פטירה לאור סטאטוס משפחתי וצורך על פי הנתונים.",
      reason: "",
      category: "INVESTMENT",
      isSelected: null,
      transactions: [
        {
          id: "7654424234",
          title: null,
          description: null,
          isDynamic: false,
          action: "NEW",
          simulation: {
            title: "כיסוי ביטוחי סכום חד פעמי במקרה פטירה ליורשיך",
            amount: "30000",
          },
          currentHoldings: [{}],
          targetHoldings: [
            {
              id: "12354355435",
              category: "INVESTMENT",
              fundId: "14855",
              fundShortText: "אנליסט קופת גמל להשקעה כללי",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "150000",
            },
          ],
        },
      ],
    },

    // new pension
    {
      id: "8",
      title: "רכישת סכום ביטוח חיים חדש",
      description: "רכישת ביטוח חיים למקרה פטירה לאור סטאטוס משפחתי וצורך על פי הנתונים.",
      reason: "",
      category: "PROVIDENT",
      isSelected: null,
      transactions: [
        {
          id: "876224234",
          title: null,
          description: null,
          isDynamic: false,
          action: "NEW",
          simulation: {
            title: "כיסוי ביטוחי סכום חד פעמי במקרה פטירה ליורשיך",
            amount: "30000",
          },
          currentHoldings: [{}],
          targetHoldings: [
            {
              id: "9999035",
              category: "PROVIDENT",
              fundId: "14855",
              fundShortText: "אנליסט קופת גמל להשקעה כללי",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "150000",
            },
          ],
        },
      ],
    },

    // complex
    {
      id: "2",
      title: "העברה קופות גמל לקרן פנסיה מקיפה",
      description: "רכישת ביטוח חיים למקרה פטירה לאור סטאטוס משפחתי וצורך על פי הנתונים.",
      reason: "",
      category: "PENSION",
      isSelected: null,
      transactions: [
        {
          id: "111124234",
          title: null,
          description: null,
          isDynamic: true,
          action: "POLICY_PARAMETERS_CHANGE",
          simulation: {
            title: "תוספת חיסכון לגיל פרישה",
            amount: "30000",
          },
          currentHoldings: [
            {
              id: "678624234",
              isSelected: true,
              category: "MANAGERS",
              fundId: "64641536",
              fundShortText: "מגדל חברה לביטוח - מגדל כושר",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              currentSavings: 6000,
            },
            {
              id: "123624234",
              isSelected: true,
              category: "MANAGERS",
              fundId: "64641536",
              fundShortText: "מגדל חברה לביטוח - מגדל כושר",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              currentSavings: 6000,
            },
            {
              id: "1067724234",
              isSelected: true,
              category: "MANAGERS",
              fundId: "64641536",
              fundShortText: "מגדל חברה לביטוח - מגדל כושר",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              currentSavings: 6000,
            },
          ],
          targetHoldings: [
            {
              id: "1000624234",
              category: "PENSION",
              fundId: "14855",
              fundShortText: "אנליסט קופת גמל להשקעה כללי",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "150000",
            },
          ],
        },
      ],
    },

    // upgrade condition
    {
      id: "3",
      title: "שיפור כיסוי אובדן כושר עבודה מ-60% ל-75%",
      description: "הגדלת גובה הפיצוי החודשי ל75% משכרך (10,000 ש״ח ).",
      reason: "הפיצוי יעודכן ע״י הגדלת הפרשת מעסיק לאובדן כושר עבודה במסגרת 2.5%.",
      category: "MANAGERS",
      isSelected: null,
      transactions: [
        {
          id: "546564789",
          title: null,
          description: null,
          isDynamic: false,
          action: "POLICY_PARAMETERS_CHANGE",
          simulation: {
            title: "שיפור כיסוי אובדן כושר עבודה מ-60% ל-75% (מקסימום)",
            amount: "30000",
          },
          currentHoldings: [
            {
              id: "324235",
              isSelected: true,
              category: "MANAGERS",
              fundId: "64641536",
              fundShortText: "מגדל חברה לביטוח - מגדל כושר",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              currentSavings: 6000,
            },
          ],
          targetHoldings: [
            {
              id: "3453556334",
              category: "MANAGERS",
              fundId: "64641536",
              fundShortText: "אנליסט קופת גמל להשקעה כללי",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              futureSavings: "7500",
            },
          ],
        },
      ],
    },

    // no change
    // {
    //   id: "4",
    //   title: "ללא שינוי",
    //   description: "קרן הפנסיה מדורגת גבוה בדמי ניהול נמוכים ורמת סיכון תואמת את העדפתך.",
    //   reason: "",
    //   category: "PENSION",
    //   isSelected: null,
    //   transactions: [
    //     {
    //       id: "16516147734",
    //       title: null,
    //       description: null,
    //       isDynamic: false,
    //       action: "NO_CHANGE",
    //       simulation: {
    //         title: "קצבה חודשית בגיל פרישה לשמירה על שגרה כלכלית",
    //         amount: "30000",
    //       },
    //       currentHoldings: [
    //         {
    //           id: "12382429",
    //           isSelected: true,
    //           category: "PENSION",
    //           fundId: "13565",
    //           fundShortText: "אנליסט קופת גמל להשקעה עוקב מדד S&P500",
    //           companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
    //           currentSavings: 26775,
    //         },
    //       ],
    //       targetHoldings: [{}],
    //     },
    //   ],
    // },

    // transfer provident to pension
    {
      id: "5",
      title: "העברה קופות גמל לקרן פנסיה מקיפה",
      description: "תוספת חיסכון לגיל פרישה",
      reason: "",
      category: "PROVIDENT",
      isSelected: null,
      transactions: [
        {
          id: "765434234",
          title: null,
          description: null,
          isDynamic: false,
          action: "POLICY_TRANSFER",
          simulation: {
            title: "תוספת חיסכון לגיל פרישה",
            amount: "30000",
          },
          currentHoldings: [
            {
              id: "1657452",
              isSelected: true,
              category: "PROVIDENT",
              fundId: "64641536",
              fundShortText: "אינפיניטי גמל מניות",
              companyLogo:
                "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/mishpatanim.png",
              currentSavings: 26775,
            },
            {
              id: "125754435429",
              isSelected: true,
              category: "PROVIDENT",
              fundId: "9916",
              fundShortText: "הפניקס גמל לבני 50 ומטה",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              currentSavings: 30481,
            },
            {
              id: "124563459",
              isSelected: true,
              category: "PROVIDENT",
              fundId: "13501",
              fundShortText: "הראל פנסיה מקיפה עוקב מדד S&P 500",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/infinity.png",
              currentSavings: 58145,
            },
          ],
          targetHoldings: [
            {
              id: "1333446789",
              category: "PROVIDENT",
              fundId: "13565",
              fundShortText: "מור פנסיה מקיפה עוקב מדד S&P 500 ",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "115401",
            },
          ],
        },
      ],
    },

    // 1 - Many
    {
      id: "6",
      title: "העברה ופיצול קופת גמל",
      description:
        "איחוד חיסכון קצבתי מקופות גמל לקרן פנסיה מקיפה להגדלת הקצבה החודשית שתשולם לך בגיל פרישה, בדמי ניהול נמוכים ובהתאמה של מסלול ההשקעה בהתאם להעדפת רמת הסיכון שלך.",
      reason: "",
      category: "PROVIDENT",
      isSelected: null,
      transactions: [
        {
          id: "435345789",
          title: null,
          description: null,
          isDynamic: false,
          action: "POLICY_TRANSFER",
          simulation: {
            title: "תוספת חיסכון לגיל פרישה",
            amount: "30000",
          },
          currentHoldings: [
            {
              id: "14444888789",
              isSelected: true,
              category: "PROVIDENT",
              fundId: "13565",
              fundShortText: "מגדל תגמולים ופיצויים עוקב מדד S&P 500",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              currentSavings: 115401,
            },
          ],
          targetHoldings: [
            {
              id: "77676769",
              category: "PROVIDENT",
              fundId: "13565",
              fundShortText: "אינפיניטי גמל מניות",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "45000",
            },
            {
              id: "99999999",
              category: "PROVIDENT",
              fundId: "13501",
              fundShortText: "הראל פנסיה מקיפה עוקב מדד S&P 500",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "70401",
            },
          ],
        },
      ],
    },

    // more then 1 transactions
    {
      id: "7",
      title: "שינויים בביטוח מנהלים - 3 שלבים",
      description: "",
      reason: "",
      category: "MANAGERS",
      isSelected: null,
      transactions: [
        {
          id: "199997779",
          title: null,
          description: null,
          isDynamic: false,
          action: "POLICY_PARAMETERS_CHANGE",
          simulation: {
            title: "הגדלת אחוז חיסכון בביטוח מנהלים מ60% ל-75%",
            amount: "30000",
          },
          currentHoldings: [
            {
              id: "15555544489",
              isSelected: true,
              category: "MANAGERS",
              fundId: "64641536",
              fundShortText: "מגדל חברה לביטוח - מגדל כושר",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              currentSavings: 6000,
            },
          ],
          targetHoldings: [
            {
              id: "177776661",
              category: "MANAGERS",
              fundId: "64641536",
              fundShortText: "אנליסט קופת גמל להשקעה כללי",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              futureSavings: "7500",
            },
          ],
        },
        {
          id: "78888867",
          title: null,
          description: null,
          isDynamic: false,
          action: "NEW",
          simulation: {
            title: "רכישת סכום ביטוח חיים חדש ",
            amount: "30000",
          },
          currentHoldings: [{}],
          targetHoldings: [
            {
              id: "65555789",

              category: "PENSION",
              fundId: "13854",
              fundShortText: "כלל ביטוח",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/klal.png",
              futureSavings: "1500000",
            },
          ],
        },
        {
          id: "8666555534",
          title: null,
          description: null,
          isDynamic: false,
          action: "POLICY_TRANSFER",
          simulation: {
            title: "העברה ופיצול קופת גמל",
            amount: "30000",
          },
          currentHoldings: [
            {
              id: "0909788789",
              isSelected: true,
              category: "PROVIDENT",
              fundId: "13565",
              fundShortText: "מגדל תגמולים ופיצויים עוקב מדד S&P 500",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/migdal.png",
              currentSavings: 115401,
            },
          ],
          targetHoldings: [
            {
              id: "211116769",
              category: "PROVIDENT",
              fundId: "13565",
              fundShortText: "אינפיניטי גמל מניות",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "45000",
            },
            {
              id: "66699",
              category: "PROVIDENT",
              fundId: "13501",
              fundShortText: "הראל פנסיה מקיפה עוקב מדד S&P 500",
              companyLogo: "https://finqfinancedevpublic.blob.core.windows.net/pensiohouselogo/analyst.png",
              futureSavings: "70401",
            },
          ],
        },
      ],
    },
  ] as unknown as PensionRecommendation[],
}
